import { memberAffordabilityTypes } from '@constants/actionTypes/ssapActionTypes';

// getInitialState function is introduced to have possibility to test in Jest
// reducer's initial state depending on environment

export const getInitialState = () => {
    const {
        __ENV__: {
            DEVELOPMENT
        } = {}
    } = global;

    return ({
        year: DEVELOPMENT ? 2020 : 0,
        percent: DEVELOPMENT ? 9.78 : 0,
    });
};

export default (state = getInitialState(), action = {}) => {
    switch (action.type) {
        case memberAffordabilityTypes.SET_MEMBER_AFFORDABILITY:
            return action.affordabilityData;
        case memberAffordabilityTypes.CLEAR_SSAP_STATE:
            return getInitialState();
        default:
            return state;
    }
};
